import { type InferType, object, string } from "yup";
import { BankAddressInputFields } from "../constants";
import { abaChecksum } from "./utils";

export const ROUTING_NUMBER_LENGTH = 9;

export enum RoutingNumberInputFields {
  RoutingNumber = "routingNumber",
  BankName = "bankName",
  BankAddress = "bankAddress",
}

export const routingNumberBaseSchema = string()
  .matches(/^(0|1|2|3).*$/, "Must begin with 0, 1, 2, or 3")
  .matches(/^[0-9]+$/, "Must be only numbers")
  .length(ROUTING_NUMBER_LENGTH, "Must be 9 digits long")
  .test("routingChecksum", "Routing number is invalid", abaChecksum);

export const bankAddressBaseSchema = object().shape({
  [BankAddressInputFields.Country]: string(),
  [BankAddressInputFields.Line1]: string(),
  [BankAddressInputFields.Line2]: string().nullable(),
  [BankAddressInputFields.Locality]: string(),
  [BankAddressInputFields.PostalCode]: string(),
  [BankAddressInputFields.Region]: string(),
});

const RoutingNumberBankSchema = object().shape({
  [RoutingNumberInputFields.BankName]: string(),
  [RoutingNumberInputFields.BankAddress]: bankAddressBaseSchema,
});

export const RoutingNumberInputSchema = object()
  .shape({
    [RoutingNumberInputFields.RoutingNumber]:
      routingNumberBaseSchema.required("Required field"),
  })
  .concat(RoutingNumberBankSchema);

export const RoutingNumberNoBankAddressInputSchema = object().shape({
  [RoutingNumberInputFields.RoutingNumber]: routingNumberBaseSchema.required("Required field"),
  [RoutingNumberInputFields.BankName]: string()
    .matches(
      /^[\x20-\x7E]*$/,
      "Bank name can only include standard letters, numbers, and common punctuation marks.",
    )
    .matches(/\S/, "Bank name cannot be just spaces.")
    .required("Required field"),
});

export type BankAddressInputType = InferType<typeof bankAddressBaseSchema>;

export type RoutingNumberInputType = InferType<typeof RoutingNumberInputSchema>;
